import React from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles
} from '@material-ui/core';
import { Customer } from 'src/types';
import { PcwUserListItem } from './components';

interface Props {
  onCustomerPress: (customer: Customer) => void;
  pcwUser?: any[];
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const Results = ({
  onCustomerPress,
  className,
  pcwUser = [],
  ...rest
}: Props) => {
  const classes = useStyles();

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>uuid</TableCell>
                <TableCell>fullname</TableCell>
                <TableCell>status</TableCell>
                <TableCell>active</TableCell>
                <TableCell>created_at</TableCell>
                <TableCell>updated_at</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pcwUser.map((item) => (
                <PcwUserListItem
                  key={item?.id}
                  customer={item}
                  onCustomerPress={onCustomerPress}
                />
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
    </Card>
  );
};

export default Results;
